import "./home-landing-brands.component.scss";

export default {
  template: require('./home-landing-brands.component.html'),
  controller: function ($t) {
    'ngInject';

    this.brands = [
      {part1: $t("public.landing.home.brand_3t"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_6ku"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_allied"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_aventon"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_cannondale"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_canyon"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_charge"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_cinelli"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_commencal"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_creme"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_detroit_bikes"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_diamondback"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_electra"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_felt"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_framed"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_fuji"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_giant"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_huffy"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_juiced_bikes"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_linus"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_priority"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_rad_power"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_retrospec"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_ride1up"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_schwinn"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_sixthreezero"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_sole_bicycles"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_state_bicycle"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_trek"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_yuba"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_scott"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_amsterdam_bicycle_company"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_azor"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_bmc"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_cube"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_gazelle"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_gt"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_jamis"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_liv"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_nordictrack"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_peloton"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_public"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_pure_fix_cycles"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_republic"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_raleigh"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_royce_union"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_specialized"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_taga"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_vilano"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_vivelo"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_a2b"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_ancheer"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_argon"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_babboe"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_biria"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_breezer"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_bunch"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_da_bomb"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_genesis"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_guardian"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_hiland"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_jetson"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_kent"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_lectric"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_leitner"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_lekker"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_luna"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_lynskey"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_magnum"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_marin"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_mate"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_michael_blast"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_mongoose"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_motobecane"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_nakto"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_pashley"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_polygon"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_propella"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_santa_cruz"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_se"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_sondors"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_tommaso"), part2: "", link: "/coming-soon"},
      {part1: $t("public.landing.home.brand_voodooo"), part2: "", link: "/coming-soon"}
    ]
  }
};
